import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Is LIMYA free to use?",
    a: "Yes. Neighbors browse, save, share, and message local pros completely free — no account needed just to look around. Pros can create a profile for free too.",
  },
  {
    q: "Does LIMYA charge pros for leads?",
    a: "Never. LIMYA does not sell or charge for leads. Neighbors reach out directly, and pros keep every conversation. Pros can optionally upgrade to Pro Plus for analytics and extra visibility.",
  },
  {
    q: "What is Pro Plus?",
    a: "Pro Plus is an optional membership for pros who want more: featured placement on the neighborhood board, engagement insights on their posts, the ability to message neighbors who invite contact, and more Wall posts per day.",
  },
  {
    q: "How does the neighborhood board work?",
    a: "Enter your ZIP code and LIMYA shows pros and posts near you. Your ZIP is only used to surface nearby results — it's never shown publicly.",
  },
  {
    q: "What's the difference between the Feed and the Wall?",
    a: "The Wall is one shared, local discovery stream for your area — pro posts, neighbor requests, and recommendations. Your Feed is personalized: it shows updates from the pros you've pinned or follow.",
  },
  {
    q: "How does LIMYA keep me safe?",
    a: "Phone numbers and street addresses are automatically blocked and masked in public posts. Keep the conversation in LIMYA messages until you're comfortable, and report anything that doesn't look right.",
  },
  {
    q: "Can I save pros for later?",
    a: "Absolutely. Pin any pro to My Board, organize them into project folders, and share a view-only board with family or friends.",
  },
];

function Item({ q, a, open, onToggle, i }) {
  return (
    <div className="border border-black/[0.07] rounded-2xl bg-white overflow-hidden" data-testid={`faq-item-${i}`}>
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-black/[0.02] transition" data-testid={`faq-toggle-${i}`}>
        <span className="font-semibold text-[#2D2926] text-[15px]" style={{ fontFamily: "Outfit" }}>{q}</span>
        <ChevronDown size={18} className={`text-[#245544] shrink-0 transition ${open ? "rotate-180" : ""}`}/>
      </button>
      {open && <p className="px-5 pb-5 -mt-1 text-sm text-[#2D2926]/70 leading-relaxed" data-testid={`faq-answer-${i}`}>{a}</p>}
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="bg-[#F5F7F5] min-h-screen">
      <Header/>
      <div className="max-w-3xl mx-auto px-6 py-14" data-testid="faq-page">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#E1EDE7] text-[#245544] text-xs font-bold uppercase tracking-wider mb-4">
          <HelpCircle size={13}/> Help Center
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#2D2926] mb-3" style={{ fontFamily: "Outfit" }}>Frequently asked questions</h1>
        <p className="text-[#5C554E] mb-9">Everything you need to know about using LIMYA as a neighbor or a pro.</p>
        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <Item key={i} i={i} {...f} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)}/>
          ))}
        </div>
        <div className="mt-10 bg-white border border-black/[0.07] rounded-2xl p-6 text-center">
          <p className="text-[#2D2926] font-semibold mb-1" style={{ fontFamily: "Outfit" }}>Still have a question?</p>
          <p className="text-sm text-[#5C554E] mb-4">We're happy to help.</p>
          <Link to="/contact" className="btn-lime inline-flex px-6 py-2.5 text-sm" data-testid="faq-contact-btn">Contact us</Link>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
